// extracted by mini-css-extract-plugin
export default {"wrapper":"ReferAndEarn_wrapper__4s7Ay","iframe":"ReferAndEarn_iframe__CxILx","errorState":"ReferAndEarn_errorState__qw4ti","retryButton":"ReferAndEarn_retryButton__LO32B"};